"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.menuActions = void 0;
exports.menuActions = {
    BACKGROUND: {
        BACKGROUND_REMOVE: ['basic.image', 'basic.color'],
        BACKGROUND_COLOR_IMAGE: ['basic.color', 'basic.image'],
        BACKGROUND_COLOR: ['basic.color'],
        BACKGROUND_OPACITY: ['opacity'],
        BACKGROUND_BG_REMOVAL: ['background_bg_removal'],
        BACKGROUND_REPOSITION: ['basic.image'],
        BACKGROUND_FILTER: ['basic.image'],
        BACKGROUND_FLIP: ['flip'],
        TRANSFORM: ['flip'],
        IMAGE_BOX: ['basic.image'],
    },
    LAYOUT: {
        LAYOUT_CONFIRM: [],
        LAYOUT_CLOSE: [],
    },
    VIDEO: {
        IMAGE_REPOSITION: ['video_position'],
        ROTATE_LEFT: ['video_rotation'],
        ROTATE_RIGHT: ['video_rotation'],
        ROTATE: ['video_rotation'],
        ORDER: ['video_position'],
        ALIGNMENT: ['video_position'],
        DECREASE: ['video_size'],
        DUPLICATE: ['video_duplication'],
        INCREASE: ['video_size'],
        LOCK: ['video_position'],
        REMOVE: ['video_deletion'],
        UNLOCK: ['video_position'],
        VIDEO_AUTOPLAY: ['video_flags'],
        VIDEO_CONTROLS: ['video_flags'],
        VIDEO_FULLSCREEN: ['video_flags'],
        VIDEO_LOOP: ['video_flags'],
        VIDEO_MOVE_TO_NEXT: ['video_flags'],
        VIDEO_MUTE: ['video_flags'],
        VIDEO_SOURCE: ['video_replace'],
    },
    VIDEO_YOUTUBE: {
        IMAGE_REPOSITION: ['video_position'],
        ROTATE_LEFT: ['video_rotation'],
        ROTATE_RIGHT: ['video_rotation'],
        ROTATE: ['video_rotation'],
        ORDER: ['video_position'],
        ALIGNMENT: ['video_position'],
        DECREASE: ['video_size'],
        DUPLICATE: ['video_duplication'],
        INCREASE: ['video_size'],
        LOCK: ['video_position'],
        REMOVE: ['video_deletion'],
        UNLOCK: ['video_position'],
        VIDEO_AUTOPLAY: ['video_flags'],
        VIDEO_CONTROLS: ['video_flags'],
        VIDEO_FULLSCREEN: ['video_flags'],
        VIDEO_LOOP: ['video_flags'],
        VIDEO_MOVE_TO_NEXT: ['video_flags'],
        VIDEO_MUTE: ['video_flags'],
        VIDEO_SOURCE: ['video_replace'],
    },
    LOGO: {
        INCREASE: ['logo_size'],
        DECREASE: ['logo_size'],
        UNLOCK: ['logo_position'],
        DUPLICATE: ['logo_duplication'],
        REMOVE: ['logo_deletion'],
        TEXT_FONTFAMILY: ['logo_font_family'],
        TEXT_FONTSIZE: ['logo_font_size'],
        OPACITY: ['logo_opacity'],
        FILL_COLOR: ['color'],
        TEXT_BOLD: ['logo_decoration'],
        TEXT_ITALIC: ['logo_decoration'],
        TEXT_UNDERLINE: ['logo_decoration'],
        TEXT_CASE: ['logo_change_content', 'logo_decoration'],
        TEXT_BULLETS: ['logo_decoration'],
        TEXT_ALIGN: ['logo_alignment'],
        LOCK: ['logo_position'],
        ORDER: ['logo_z_index'],
        ROTATE_LEFT: ['logo_rotation'],
        ROTATE_RIGHT: ['logo_rotation'],
        ROTATE: ['logo_rotation'],
        TEXT_TYPING: ['logo_change_content'],
        ALIGNMENT: ['logo_position'],
        TEXT_SPACING: ['logo_spacing'],
        LINK: ['logo_replace'],
        UNLINK: ['logo_replace'],
    },
    ICON: {
        INCREASE: ['icon_size'],
        DECREASE: ['icon_size'],
        UNLOCK: ['icon_position'],
        DUPLICATE: ['icon_duplication'],
        REMOVE: ['icon_deletion'],
        TEXT_FONTFAMILY: ['icon_font_family'],
        TEXT_FONTSIZE: ['icon_font_size'],
        OPACITY: ['icon_opacity'],
        FILL_COLOR: ['icon_colour', 'color'],
        STROKE_COLOR: ['icon_stroke'],
        TEXT_BOLD: ['icon_decoration'],
        TEXT_ITALIC: ['icon_decoration'],
        TEXT_UNDERLINE: ['icon_decoration'],
        TEXT_CASE: ['icon_change_content', 'icon_decoration'],
        TEXT_BULLETS: ['icon_decoration'],
        TEXT_ALIGN: ['icon_alignment'],
        LOCK: ['icon_position'],
        ORDER: ['icon_z_index'],
        ROTATE_LEFT: ['icon_rotation'],
        ROTATE_RIGHT: ['icon_rotation'],
        ROTATE: ['icon_rotation'],
        TEXT_TYPING: ['icon_change_content'],
        ALIGNMENT: ['icon_position'],
        TEXT_SPACING: ['icon_spacing'],
        LINK: ['icon_replace'],
        UNLINK: ['icon_replace'],
    },
    TEXT: {
        INCREASE: ['text_size'],
        DECREASE: ['text_size'],
        UNLOCK: ['text_position'],
        DUPLICATE: ['text_duplication'],
        REMOVE: ['text_deletion'],
        TEXT_FONTFAMILY: ['text_font_family'],
        TEXT_FONTSIZE: ['text_font_size'],
        TEXT_HEADING: ['text_font_size'],
        TEXT_LINK: ['text_font_size'],
        OPACITY: ['text_opacity'],
        FILL_COLOR: ['text_colour', 'color'],
        STROKE_COLOR: ['text_colour'],
        TEXT_BOLD: ['text_decoration'],
        TEXT_ITALIC: ['text_decoration'],
        TEXT_UNDERLINE: ['text_decoration'],
        TEXT_CASE: ['text_decoration'],
        TEXT_BULLETS: ['text_decoration'],
        TEXT_LIST: ['text_decoration'],
        TEXT_ALIGN: ['text_alignment'],
        LOCK: ['text_position'],
        ORDER: ['text_z_index'],
        ROTATE_LEFT: ['text_rotation'],
        ROTATE_RIGHT: ['text_rotation'],
        ROTATE: ['text_rotation'],
        TEXT_TYPING: ['text_change_content'],
        TEXT_COLUMNS: ['text_change_content'],
        LINK: ['text_change_content'],
        UNLINK: ['text_change_content'],
        REMOVE_STYLE: ['text_decoration'],
        ALIGNMENT: ['text_position'],
        TEXT_SPACING: ['text_spacing'],
        PARAGRAPH_SPACING: ['text_spacing'],
        HIGHLIGHT_COLOR: ['text_highlight'],
    },
    TEXT_EDIT: {
        INCREASE: ['text_size'],
        DECREASE: ['text_size'],
        UNLOCK: ['text_position'],
        DUPLICATE: ['text_duplication'],
        REMOVE: ['text_deletion'],
        TEXT_FONTFAMILY: ['text_font_family'],
        TEXT_FONTSIZE: ['text_font_size'],
        TEXT_HEADING: ['text_font_size'],
        TEXT_LINK: ['text_font_size'],
        OPACITY: ['text_opacity'],
        FILL_COLOR: ['text_colour', 'color'],
        STROKE_COLOR: ['text_colour'],
        TEXT_BOLD: ['text_decoration'],
        TEXT_ITALIC: ['text_decoration'],
        TEXT_UNDERLINE: ['text_decoration'],
        TEXT_CASE: ['text_decoration'],
        TEXT_BULLETS: ['text_decoration'],
        TEXT_LIST: ['text_decoration'],
        TEXT_ALIGN: ['text_alignment'],
        LOCK: ['text_position'],
        ORDER: ['text_z_index'],
        ROTATE_LEFT: ['text_rotation'],
        ROTATE_RIGHT: ['text_rotation'],
        ROTATE: ['text_rotation'],
        TEXT_TYPING: ['text_change_content'],
        TEXT_COLUMNS: ['text_change_content'],
        LINK: ['text_change_content'],
        UNLINK: ['text_change_content'],
        REMOVE_STYLE: ['text_decoration'],
        ALIGNMENT: ['text_position'],
        TEXT_SPACING: ['text_spacing'],
        PARAGRAPH_SPACING: ['text_spacing'],
        HIGHLIGHT_COLOR: ['text_highlight'],
    },
    TABLE: {
        CELL_BACKGROUND: ['table_object_color'],
        CELL_BORDER_COLOR: ['table_object_color'],
        CELL_COLOR: ['table_text_color'],
        CELL_HIGHLIGHT: ['table_text_color'],
        CELL_EDIT_BORDER: ['table_object_style'],
        CELL_MERGE: ['table_merge_split'],
        CELL_SPLIT: ['table_merge_split'],
        CELL_BOLD: ['table_text_style'],
        CELL_BULLETS: ['table_text_style'],
        CELL_CASE: ['table_text_style'],
        CELL_EDIT_ALIGNMENT: ['table_text_style'],
        CELL_FONT: ['table_text_style'],
        CELL_FONT_FAMILY: ['table_text_style'],
        CELL_FONT_SIZE: ['table_text_style'],
        CELL_ITALIC: ['table_text_style'],
        CELL_LIST: ['table_text_style'],
        CELL_SPACING: ['table_text_style'],
        CELL_TEXT_ALIGNMENT: ['table_text_style'],
        CELL_UNDERLINE: ['table_text_style'],
        COLUMN_DELETE: ['table_row_column'],
        COLUMN_INSERT_AFTER: ['table_row_column'],
        COLUMN_INSERT_BEFORE: ['table_row_column'],
        DUPLICATE: ['table_duplication'],
        LOCK: ['table_position'],
        OPACITY: ['table_opacity'],
        ORDER: ['table_z_index'],
        REMOVE: ['table_deletion'],
        ROTATE: ['table_rotation'],
        ROW_DELETE: ['table_row_column'],
        ROW_INSERT_AFTER: ['table_row_column'],
        ROW_INSERT_BEFORE: ['table_row_column'],
        TABLE_ROWS_AND_COLUMNS: ['table_row_column'],
        UNLOCK: ['table_position'],
    },
    TABLE_EDIT: {
        CELL_BACKGROUND: ['table_object_color'],
        CELL_BORDER_COLOR: ['table_object_color'],
        CELL_COLOR: ['table_text_color'],
        CELL_HIGHLIGHT: ['table_text_color'],
        CELL_EDIT_BORDER: ['table_object_style'],
        CELL_MERGE: ['table_merge_split'],
        CELL_SPLIT: ['table_merge_split'],
        CELL_BOLD: ['table_text_style'],
        CELL_BULLETS: ['table_text_style'],
        CELL_CASE: ['table_text_style'],
        CELL_EDIT_ALIGNMENT: ['table_text_style'],
        CELL_FONT: ['table_text_style'],
        CELL_FONT_FAMILY: ['table_text_style'],
        CELL_FONT_SIZE: ['table_text_style'],
        CELL_ITALIC: ['table_text_style'],
        CELL_LIST: ['table_text_style'],
        CELL_SPACING: ['table_text_style'],
        CELL_TEXT_ALIGNMENT: ['table_text_style'],
        CELL_UNDERLINE: ['table_text_style'],
        COLUMN_DELETE: ['table_row_column'],
        COLUMN_INSERT_AFTER: ['table_row_column'],
        COLUMN_INSERT_BEFORE: ['table_row_column'],
        DUPLICATE: ['table_duplication'],
        LOCK: ['table_position'],
        OPACITY: ['table_opacity'],
        ORDER: ['table_z_index'],
        REMOVE: ['table_deletion'],
        ROTATE: ['table_rotation'],
        ROW_DELETE: ['table_row_column'],
        ROW_INSERT_AFTER: ['table_row_column'],
        ROW_INSERT_BEFORE: ['table_row_column'],
        TABLE_ROWS_AND_COLUMNS: ['table_row_column'],
        UNLOCK: ['table_position'],
    },
    IMAGE: {
        INCREASE: ['image_size'],
        DECREASE: ['image_size'],
        UNLOCK: ['image_position'],
        DUPLICATE: ['image_duplication'],
        REMOVE: ['image_deletion'],
        IMAGE_REPOSITION: ['image_crop'],
        IMAGE_FILTER: ['image_filter'],
        OPACITY: ['image_opacity'],
        LOCK: ['image_position'],
        ORDER: ['image_z_index'],
        ROTATE_LEFT: ['image_rotation'],
        ROTATE_RIGHT: ['image_rotation'],
        ROTATE: ['image_rotation'],
        FLIP_IMAGE_H: ['image_rotation'],
        FLIP_IMAGE_V: ['image_rotation'],
        FLIP_IMAGE: ['image_rotation'],
        ALIGNMENT: ['image_position'],
        SET_BACKGROUND: ['image_set_background'],
        SET_BG_REMOVAL: ['image_bg_removal'],
        LINK: ['image_content'],
        UNLINK: ['image_content'],
        IMAGE_BG_REMOVAL: ['image_content'],
    },
    VECTOR: {
        INCREASE: ['vector_size'],
        DECREASE: ['vector_size'],
        UNLOCK: ['vector_position'],
        DUPLICATE: ['vector_duplication'],
        REMOVE: ['vector_deletion'],
        IMAGE_REPOSITION: ['image_crop'],
        OPACITY: ['vector_opacity'],
        FILL_COLOR: ['vector_colour', 'color'],
        STROKE_COLOR: ['vector_stroke'],
        STROKE: ['vector_stroke'],
        FLIP_H: ['vector_rotation'],
        FLIP_V: ['vector_rotation'],
        FLIP: ['vector_rotation'],
        LOCK: ['vector_position'],
        ORDER: ['vector_z_index'],
        ROTATE_LEFT: ['vector_rotation'],
        ROTATE_RIGHT: ['vector_rotation'],
        ROTATE: ['vector_rotation'],
        ALIGNMENT: ['vector_position'],
        LINK: ['vector_replace'],
        UNLINK: ['vector_replace'],
        IMAGE_BOX: ['vector_replace'],
    },
    STICKER: {
        INCREASE: ['vector_size'],
        DECREASE: ['vector_size'],
        UNLOCK: ['vector_position'],
        DUPLICATE: ['vector_duplication'],
        REMOVE: ['vector_deletion'],
        IMAGE_REPOSITION: ['image_crop'],
        OPACITY: ['vector_opacity'],
        FILL_COLOR: ['vector_colour', 'color'],
        STROKE_COLOR: ['vector_stroke'],
        STROKE: ['vector_stroke'],
        FLIP_H: ['vector_rotation'],
        FLIP_V: ['vector_rotation'],
        FLIP: ['vector_rotation'],
        LOCK: ['vector_position'],
        ORDER: ['vector_z_index'],
        ROTATE_LEFT: ['vector_rotation'],
        ROTATE_RIGHT: ['vector_rotation'],
        ROTATE: ['vector_rotation'],
        ALIGNMENT: ['vector_position'],
        LINK: ['vector_replace'],
        UNLINK: ['vector_replace'],
        IMAGE_BOX: ['vector_replace'],
    },
    QRCODE: {
        INCREASE: ['qrcode_size'],
        DECREASE: ['qrcode_size'],
        UNLOCK: ['qrcode_position'],
        DUPLICATE: ['qrcode_duplication'],
        REMOVE: ['qrcode_deletion'],
        OPACITY: ['qrcode_opacity'],
        FILL_COLOR: ['qrcode_colour', 'color'],
        LOCK: ['qrcode_position'],
        ORDER: ['qrcode_z_index'],
        ROTATE_LEFT: ['qrcode_rotation'],
        ROTATE_RIGHT: ['qrcode_rotation'],
        ROTATE: ['qrcode_rotation'],
        ALIGNMENT: ['qrcode_position'],
        LINK: ['qrcode_replace'],
        UNLINK: ['qrcode_replace'],
    },
    DEFAULT: {
        INCREASE: ['element_size'],
        DECREASE: ['element_size'],
        UNLOCK: ['element_position'],
        DUPLICATE: ['element_duplication'],
        REMOVE: ['element_deletion'],
        GROUP_UNGROUP: ['element_ungrouping'],
        OPACITY: ['element_opacity'],
        LOCK: ['element_position'],
        ORDER: ['element_z_index'],
        ROTATE_LEFT: ['element_rotation'],
        ROTATE_RIGHT: ['element_rotation'],
        ROTATE: ['element_rotation'],
        ALIGNMENT: ['element_position'],
        GROUP_GROUP: ['element_grouping'],
        IMAGE_BOX: ['image_content'],
        FILL_COLOR: ['element_colour'],
        STROKE_COLOR: ['vector_stroke'],
        STROKE: ['vector_stroke'],
        FLIP_H: ['element_rotation'],
        FLIP_V: ['element_rotation'],
        FLIP: ['element_rotation'],
    },
    GROUP: {},
    MULTISELECT: {},
    HEADER_AND_FOOTER: {},
    BLEED: {},
    ROOT: {
        ROOT_DRAWING: ['function_draw'],
        ROOT_SHAPES: ['vector_add'],
        ROOT_FRAMES: ['image_add'],
        ROOT_TEXT: ['text_add'],
        ROOT_TABLE: ['table_add'],
    },
};
//# sourceMappingURL=menu-actions.js.map